import { useTranslation } from "react-i18next";
import { BaseItemSelector } from "@/components/shared/BaseItemSelector";
import { useServices } from "@/hooks/use-services";
import type { Service } from "@onsemble/shared";

interface SelectedServicesListProps {
  orgId: string;
  selectedServices: string[];
  setSelectedServices: (services: string[]) => void;
  serviceCustomPrices: Record<string, number>;
  setServiceCustomPrices: (prices: Record<string, number>) => void;
  serviceCustomNames: Record<string, string>;
  setServiceCustomNames: (names: Record<string, string>) => void;
  isAddingService?: boolean;
  setIsAddingService?: (isAdding: boolean) => void;
}

export function SelectedServicesList({
  orgId,
  selectedServices,
  setSelectedServices,
  serviceCustomPrices,
  setServiceCustomPrices,
  serviceCustomNames,
  setServiceCustomNames,
  isAddingService = false,
  setIsAddingService = () => {},
}: SelectedServicesListProps) {
  const { t } = useTranslation();
  const { services, isLoading, error } = useServices();

  return (
    <BaseItemSelector<Service>
      orgId={orgId}
      items={services}
      isLoading={isLoading}
      error={error}
      selectedItems={selectedServices}
      setSelectedItems={setSelectedServices}
      customPrices={serviceCustomPrices}
      setCustomPrices={setServiceCustomPrices}
      customNames={serviceCustomNames}
      setCustomNames={setServiceCustomNames}
      apiEndpoint="/api/services"
      queryKey="/api/services"
      itemType="service"
      itemTypeCapitalized={t("components.services.selectedServicesList.service")}
      itemTypePlural={t("common.services")}
      showDescription={true}
      descriptionLabel={t("components.services.selectedServicesList.descriptionOptional")}
      descriptionPlaceholder={t("components.services.selectedServicesList.detailedDescriptionOfThe")}
      isAddingItem={isAddingService}
      setIsAddingItem={setIsAddingService}
    />
  );
}
